<ng-container *ngIf="sourceLanguage$ | async"></ng-container>
<div class="translation-key">
  <div>
    <label style="padding-right: 10px">{{label||'Translation Key'}}</label>
    <p-button variant="text" *ngIf="hasLoaded" (click)="openUpdateTranslation()">
      Update Translation
    </p-button>
  </div>
  <div>
    <ng-container *ngIf="!hasLoaded; else selection">
      <span style="padding: 10px; display: flex; justify-content: center"
        ><i class="fas fa-spinner fa-spin"></i
      ></span>
    </ng-container>
    <ng-template #selection>
      <p-select ngDefaultControl [options]="options" [virtualScroll]="true" [virtualScrollItemSize]="30" [(ngModel)]="selectedKey" optionLabel="label"
      optionValue="key" (onChange)="updateValue($event)"/>
    </ng-template>
  </div>
</div>
